import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

const STUDENT = 'student'
const PROBLEM_AREAS = 'problem_areas'
const PARENT_DISCUSSION = 'parent_discussion'
const COMMENT = 'comment'
const DOCUMENTS = 'documents'

const today = new Date()
today.setHours(0, 0, 0, 0)

/**
 * Form model
 */
const formModel = () => {
  return {
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
    },
    [PROBLEM_AREAS]: {
      label: `${t('common.problem-areas')}`,
      name: PROBLEM_AREAS,
      required: false,
    },
    [COMMENT]: {
      label: `${t('common.comment')}`,
      name: COMMENT,
      required: false,
    },
    [PARENT_DISCUSSION]: {
      label: `${t('rti.parent-discussion')}`,
      name: PARENT_DISCUSSION,
      required: false,
    },
    [DOCUMENTS]: {
      label: `${t('rti.performance-documents')}`,
      name: DOCUMENTS,
      required: false,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [STUDENT]: null,
  [PROBLEM_AREAS]: [],
  [PARENT_DISCUSSION]: false,
  [COMMENT]: '',
  [DOCUMENTS]: [],
}

export default formModel
